module.exports = __webpack_public_path__ + "img/conahcyt-blanco.ea5b18c8.svg";